import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=76af8ab8&lang=pug&"
import script from "./Viewer.vue?vue&type=script&lang=ts&"
export * from "./Viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports